export default __webpack_public_path__ + "static/media/zomato.c610aed0.svg";